import React from "react";
import ClubsPanel from "@/pages/admin/ClubsPanel";
import LegacyHost from "@/pages/admin/os/LegacyHost";

export default function ClubModule() {
  return (
    <LegacyHost
      title="Club"
      migratedFrom="Editorial desk · Clubs catalogue"
      testid="os-modules-club"
    >
      <ClubsPanel />
    </LegacyHost>
  );
}
